<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Submódulos</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovoSubModulo" />

    <SGPTabelaComponent
      v-if="listaDeSubModulos.length"
      :colunas="colunas"
      :dados="listaDeSubModulos"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>
    
    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Submódulo"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioSubModuloComponent
        :tipoFormulario="tipoFormulario"
        :submodulo="submodulo"
      />
    </SGPModalComponent> 
    
    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingSubModulo" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioSubModuloComponent from '../components/FormularioSubModuloComponent.vue'

export default {
  components: { FormularioSubModuloComponent },
  name: 'SubModuloPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      subModulosSelecionados: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      submodulo: {}
    }
  },
  created () {
    this.listarSubModulos();
  },
  computed: {
    ...mapGetters('submodulos', ['listaDeSubModulos','loadingSubModulo']),

    colunas () {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        }, 
        {
          key: 'submodulo',
          label: 'Nome',
          sortable: false
        },
        {
          key: 'acl_modulo.modulo',
          label: 'Módulo',
          sortable: false
        }
      ]
    }
  },

  methods: {
    ...mapActions('submodulos', ['listarSubModulos','excluirSubModulos']),

    gerenciadorDeSelecionados (selecionados) {
      this.subModulosSelecionados = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.submodulo = this.subModulosSelecionados[0];
      this.abrirModal = true;
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirSubModulos(this.subModulosSelecionados);
      this.deletarDados = false;
    },

    adicionarNovoSubModulo () {
      this.subModulo = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    }

  }
}
</script>
